import { render, staticRenderFns } from "./Timers.vue?vue&type=template&id=7b34ded9&lang=pug"
import script from "./Timers.vue?vue&type=script&lang=ts"
export * from "./Timers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports